<template>
  <div class="message-box">
    <div class="message-content">
      <img class="close" :src="closeBtnGrayPic" @click="close"/>
      <div class="content">
        <slot name="context"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MessageBox",
  data() {
    return {
      closeBtnGrayPic: require("@/assets/MediaCenter/close_btn_gray.png")
    }
  },
  methods: {
    close() {
      this.$emit('close', true)
    }
  }
}
</script>

<style lang="less" scoped>
.message-box {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 100;
  background-color: rgba(0,0,0,.5);
}
.message-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 288px;
  text-align: center;
  
  border-radius: 15px;
  color: #b3c1ca;
  background-color: #ffffff;

  & .close {
    position: absolute;
    top: 15px;
    right: 15px;
    height: 20px;
    width: 20px;
    z-index: 1;
    &:active {
      opacity: .6;
    }
  }
  & .content {
    font-size: 1rem;
    line-height: 1.6;
    padding: 40px 15px;
  }
}
</style>
